import SegmentedControl from './segmented-control';
export default SegmentedControl;
